import React, { Component,Suspense } from 'react';
import { palette } from '@material-ui/system';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField,
  Typography,
  LinearProgress,
  Avatar} from '@material-ui/core';
import Configuration from '../../service/configuration';
import Resources from '../../service/resources';
import DataServices from '../../service/data-services';
import cookie from 'react-cookies';
import { blue, orange } from '@material-ui/core/colors';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Footer } from '../../layouts/Main/components';
import { useTranslation, withTranslation } from 'react-i18next'


class Login extends Component{
    
    constructor(props) {
        super(props);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.validate = this.validate.bind(this);
        this.onLogin = this.onLogin.bind(this);
        this.keyPress = this.keyPress.bind(this);
      
      this.state = {
        login:{
            username:'',
            password:''
        },          
        errors:{ 
            username:null,
            password:null,
            error:false, 
            errorMessage:''
        },
        message: false,
        loading: false
      };

      this.config = new Configuration( );
      this.resources = new Resources();
      this.dataService = new DataServices( );
      this.t = this.props.lang;
      this.i18n = this.props.i18n;
    }
    
    // updating state data when text box data changed
    handleValueChange(event) {
        this.setState(Object.assign(this.state.login,{ [event.target.name]:event.target.value}));
    }
    
    render(){
        return(
                <div style={{paddingTop: "4%"}}>

                <div style={{height:"100%", paddingTop:"3%"}}>
                 <Grid container direction="row" style={{ height: "100%"}}
                                        justify="center" alignItems="center" display="flex" >

                     <Grid item  md={4} sm={6} xs={9} lg={4} xl={2} >
                         <Card >
                         <CardContent>
                            <Grid container spacing={2} direction="row" justify="center" alignItems="center" display="flex" >
                                <Grid container item orientation="row" alignItems='center' justify='center'>
                                {/*<Avatar
                                     alt={this.t('site.name')}
                                     src={"qq-web-logo.png"}
                                     style={{width: 150,height: 150}} /> */}
                                     <img alt="Delivery management platform" src={"/logo.png"} style= { {width: '150px' }}  />
                                </Grid>

                                <Grid container item orientation="row" alignItems='center' justify='center'>
                                    <Typography variant="subtitle1" color="primary">
                                      {this.t('site.name')}
                                    </Typography>
                                </Grid>


                                <Grid item md={12} xs={12}>
                                    <TextField
                                    value={this.state.login.username}
                                    onChange={this.handleValueChange}
                                    required error={this.state.errors.username?true:false} helperText={this.state.errors.username}
                                    fullWidth
                                     variant="outlined"
                                     name="username"
                                     type="text"
                                     label={this.t('login.username')}
                                     margin="dense"
                                     onKeyDown={this.keyPress} />
                                </Grid>
                                <Grid item md={12} xs={12}>
                                    <TextField
                                        value={this.state.login.password}
                                        onChange={this.handleValueChange}
                                        required error={this.state.errors.password?true:false} helperText={this.state.errors.password}
                                        fullWidth
                                        variant="outlined"
                                        name="password"
                                        type="password"
                                        label={this.t('login.password')}
                                        margin="dense"
                                        onKeyDown={this.keyPress} />
                                </Grid>

                            </Grid>
                         </CardContent>

                            <Divider />
                            <CardActions>
                            <Grid container spacing={3} direction="row" justify="center" display="flex" >
                                <Grid item md={12} xs={12}>
                                   <Button color="primary" variant="contained" style={{width:"100%"}}
                                         onClick={event => this.onLogin()} disabled={this.state.loading} >
                                       Login
                                   </Button>
                                </Grid>
                            </Grid>
                            </CardActions>
                            <CardActions>
                            <Grid container spacing={3} >
                                <Grid item md={6} xs={6}>
                                    <Button color="secondary" style={{textTransform: 'none', width:"100%",textDecoration: 'underline'}}
                                        onClick={(event) => {window.location.href= '/password-reset';}} disabled={this.state.loading} >
                                      Register
                                    </Button>
                                </Grid>
                                <Grid item md={6} xs={6}>
                                    <Button color="secondary" style={{textTransform: 'none', width:"100%",textDecoration: 'underline'}}
                                        onClick={(event) => {window.location.href= '/password-reset';}} disabled={this.state.loading} >
                                      Get password?
                                    </Button>
                                </Grid>
                            </Grid>
                            </CardActions>
                            {this.state.loading && <LinearProgress />}
                         </Card>
                     </Grid>
                 </Grid>
                </div>

                <Snackbar open={this.state.errors.error} autoHideDuration={5000} 
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                     onClose={ ( event ) => { this.setState(Object.assign(this.state.errors,{ ['error']: false }));}}>
                    <MuiAlert severity="error" elevation={6} variant="filled"
                    onClose={ ( event ) => { this.setState(Object.assign(this.state.errors,{ ['error']: false }));}} >
                      {this.state.errors.errorMessage}
                    </MuiAlert>
                </Snackbar>

                </div>
        );
    }
        
    // this method start works after loading the webpage
    componentDidMount() {
        if( this.dataService.checkTokenFromCookie()
        && window.sessionStorage.getItem(this.config.COOKIE_NAME_TOKEN)
        && this.dataService.getCurrentUserData( )
        && this.dataService.getAuthoritiesData( )){

            var auth = this.dataService.getAuthoritiesData( );
            this.userData = this.dataService.getCurrentUserData();

            if( this.userData.roleName ==='Employee' )
                window.location.href= '/deman_detail/' + this.userData.guid+'/'+this.userData.name+'/'+this.userData.personId+'/0';
            else if( this.userData.roleName ==='OS' || this.userData.roleName ==='Customer' )
                window.location.href= '/merchant_detail/' + this.userData.guid+'/'+this.userData.name+'/'+this.userData.personId+'/0';
            else{
                window.location.href= '/organization_admin_dashboard';
            }
        }
        this.i18n.changeLanguage(this.dataService.getLanguage());
    }
        
    keyPress(e){
      if(e.keyCode === 13){
         this.onLogin();
      }
   }
    // ********************         START of login      **************************************************
    onLogin(  ){
        if( this.state.message){return;}

        if( this.validate()){
            this.state.errors.error = false;
            this.state.errors.errorMessage = null;
            this.setState({loading:true});

            this.dataService.authorize( this.state.login,
            this.config.SERVICE_NAME_USER + this.config.SERVICE_ACTION_USER_LOGIN).then(items => {
                if( items ) {
                    let d = new Date();
                    d.setTime( d.getTime() + ( items.data.expires_in * 1000 ) );
                    cookie.remove( this.config.COOKIE_NAME_TOKEN, { path: '/' });
                    cookie.save(this.config.COOKIE_NAME_TOKEN, items.data.access_token, { path: '/', d, maxAge:items.data.expires_in });
                    cookie.save(this.config.COOKIE_NAME_LOGIN_USER_NAME, this.state.login.username, { path: '/', d, maxAge:items.data.expires_in });
                    window.sessionStorage.setItem(this.config.COOKIE_NAME_TOKEN, items.data.access_token);
                    this.loadBrief( );
                }else{
                    this.dataService.removeUserData();
                    this.state.loading = false;
                    this.state.errors.error = true;
                    this.state.errors.errorMessage = this.config.MESSAGE_AUTH_FAILED;
                    this.setState(prevState => ({prevState}));
                }
            });
        }
    }

    validate(){
        if( !this.state.login.username ){
            this.state.errors.username = 'Username must be entered.';
            this.state.errors.error = true;
            this.state.errors.errorMessage = 'Username must be entered.';
            this.setState({loading:false});
            return false;
        }else{
            this.state.errors.username = null;
            this.state.errors.error = false;
            this.state.errors.errorMessage = null;
            this.setState({loading:false});
        }
        
        if( !this.state.login.password ){
            this.state.errors.password = 'Password must be entered.';
            this.state.errors.error = true;
            this.state.errors.errorMessage = 'Password must be entered.';
            this.setState({loading:false});
            return false;
        }else{
            this.state.errors.password = null;
            this.state.errors.error = false;
            this.state.errors.errorMessage = null;
            this.setState({loading:false});
        }
        return true;
    }
    // ********************         END of saving/updating        **************************************************

    loadBrief(){
        this.dataService.retrieve( this.config.SERVICE_NAME_USER, this.config.SERVICE_ACTION_USER_BRIEF).then(items => {
            if( items ) {
                    this.dataService.storeCurrentUserData( items.success? items.data : null );
                    this.loadAuthorities( );
            }else{
                this.dataService.removeUserData();
                this.state.errors.error = true;
                this.state.errors.errorMessage = this.config.MESSAGE_AUTH_FAILED;
                this.setState({loading:false});
            }
        });
    }

    loadAuthorities( ){
        this.dataService.retrieve( this.config.SERVICE_NAME_USER,
        this.config.SERVICE_ACTION_USER_ROLE_CHECK ).then(items => {
            if( items ) {
                var auth = items.data.authorities;
                window.sessionStorage.setItem(this.config.COOKIE_NAME_AUTH, auth);
                this.userData = this.dataService.getCurrentUserData();

                if( this.userData.roleName ==='Employee' ){
                    window.location.href= '/deman_detail/' + this.userData.guid+'/'+this.userData.name+'/'+this.userData.personId+'/0';
                }else if( this.userData.roleName ==='OS' ){
                    this.loadJoinedBranch();
                }else{
                    window.location.href= '/organization_admin_dashboard';
                }
            }else{
                this.dataService.removeUserData();
                this.state.errors.error = true;
                this.state.errors.errorMessage = this.config.MESSAGE_AUTH_FAILED;
                this.setState({loading:false});
            }
        });
    }

    loadJoinedBranch(){
        this.dataService.retrieve( this.config.SERVICE_NAME_DEPARTMENT,
        this.config.SERVICE_ACTION_DEPARTMENT_LIST_JOINED).then(items => {
            if( items ) {
                    this.dataService.storeJoinedBranches( items.success? items.data : null );
                    this.userData = this.dataService.getCurrentUserData();
                    this.loadPOSPrivilege();
//                    window.location.href= '/merchant_detail/' + this.userData.guid+'/'+this.userData.name+'/'+this.userData.personId+'/0';
            }else{
                this.dataService.removeUserData();
                this.state.errors.error = true;
                this.state.errors.errorMessage = this.config.MESSAGE_AUTH_FAILED;
                this.setState({loading:false});
            }
        });
    }

    loadPOSPrivilege(){
        this.dataService.retrieve( this.config.SERVICE_NAME_SETTINGS,
        this.config.SERVICE_ACTION_SETTINGS_LOCAL_BY_NAME+'allow_pos?merchantGuid='+this.userData.guid ).then(items => {
            if( items && items.success ) {
                    this.dataService.setCurrentUserPOSPrivilege( items.success? items.data : null );
                    this.userData = this.dataService.getCurrentUserData();
                    window.location.href= '/merchant_detail/' + this.userData.guid+'/'+this.userData.name+'/'+this.userData.personId+'/0';
            }else{
                window.location.href= '/merchant_detail/' + this.userData.guid+'/'+this.userData.name+'/'+this.userData.personId+'/0';
            }
        });
    }
}
//export default withRouter(Login);
//export default Login;
export default (props) => {
    const { t, i18n } = useTranslation();
    return (<Login lang={t} i18n={i18n} props{... props} />)
}